/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsUserControllerGetDescriptionGenerationQueueItemQueryResponse,
  TelegramProductsUserControllerGetDescriptionGenerationQueueItemPathParams,
  TelegramProductsUserControllerGetDescriptionGenerationQueueItem401,
  TelegramProductsUserControllerGetDescriptionGenerationQueueItem404,
} from '../types/TelegramProductsUserControllerGetDescriptionGenerationQueueItem.ts';

function getTelegramProductsUserGetDescriptionGenerationQueueItemUrl(
  queueId: TelegramProductsUserControllerGetDescriptionGenerationQueueItemPathParams['queueId'],
) {
  const res = { method: 'GET', url: `/api/user/telegram/products/description-generation/queue/${queueId}` as const };
  return res;
}

/**
 * {@link /api/user/telegram/products/description-generation/queue/:queueId}
 */
export async function telegramProductsUserGetDescriptionGenerationQueueItem(
  queueId: TelegramProductsUserControllerGetDescriptionGenerationQueueItemPathParams['queueId'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramProductsUserControllerGetDescriptionGenerationQueueItemQueryResponse,
    ResponseErrorConfig<
      | TelegramProductsUserControllerGetDescriptionGenerationQueueItem401
      | TelegramProductsUserControllerGetDescriptionGenerationQueueItem404
    >,
    unknown
  >({
    method: 'GET',
    url: getTelegramProductsUserGetDescriptionGenerationQueueItemUrl(queueId).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
